// removed by extract-text-webpack-plugin
module.exports = {"list__item":"List-hashed__list__item__1wMZQ","list__itemContent":"List-hashed__list__itemContent__-WK_p","list__dataWrap":"List-hashed__list__dataWrap__UtN7i","list__data":"List-hashed__list__data__1q_wQ","list__dataLabel":"List-hashed__list__dataLabel__3zZTl"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/Mobile/List-hashed.scss
// module id = 670
// module chunks = 0